const GET_INVOICE_MERCHANTS = "GET_INVOICE_MERCHANTS";
const GET_INVOICE_MERCHANTS_SUCCESS = "GET_INVOICE_MERCHANTS_SUCCESS";
const GET_INVOICE_MERCHANTS_FAILURE = "GET_INVOICE_MERCHANTS_FAILURE";
const CLEAR_GET_INVOICE_MERCHANTS = "CLEAR_GET_INVOICE_MERCHANTS";
const GetInvoiceMerchantsSymbols = {
  GET_INVOICE_MERCHANTS_SUCCESS,
  GET_INVOICE_MERCHANTS_FAILURE,
  GET_INVOICE_MERCHANTS,
  CLEAR_GET_INVOICE_MERCHANTS,
};
export default GetInvoiceMerchantsSymbols;
